export var interactionSpans = [];
export function addCustomSpans(name, start) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
  var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var customSpan = {
    type: 'custom',
    name: name,
    start: start,
    end: end,
    labelStack: [{
      name: 'custom'
    }],
    size: size
  };
  interactionSpans.push(customSpan);
}